import React from 'react';
import EnvioCorreoRecuperacion from './EnvioCorreoRecuperacion';

function IndexEnvioCorreoRecuperacion() {
	return (
		<div data-testid="envio-correo-recuperacion" className="flex justify-center">
			<EnvioCorreoRecuperacion />
		</div>
	);
}

export default IndexEnvioCorreoRecuperacion;
